import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
	return (
		<div className={styles.main}>
			<div className={styles.container}>
				<p>
					Design by Anand. Copyright @2023.
				</p>
			</div>
		</div>
	)
}

export default Footer